import cx from 'classnames';
import { Col } from '../../../../../../../shared/frontend/components/grid/Col';
import { Row } from '../../../../../../../shared/frontend/components/grid/Row';
import { useMedia } from '../../../../../../../shared/frontend/components/grid/hooks';
import { TrackedLink } from '../../../../../../../shared/frontend/components/link';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import { InteractiveStreamPreview, MEDIUM_SIZE, SMALL_SIZE } from './shared';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { stripPathLocale } from '../../../../../../../shared/common/localeShared';

const ARKHERON_GAME_ID = '1295872446';

export function isArkheronMastheadActive(props: any) {
  const location = useLocation();
  const path = stripPathLocale(location.pathname);
  return (path === '' || path === '/') && props.streamers?.[0]?.stream?.game_id === ARKHERON_GAME_ID;
}

const CTA_URL = 'https://rio.gg/ArkheronDemoSteam';
const IMPRESSION_TRACKING_ASSET_URL = 'https://rio.gg/ArkheronDemoImp';

// We want to dynamically add a date here to ensure browser isn't caching it
const ImpressionTracker: React.FC<any> = (props: any) => {
  const [date] = useState(() => new Date().getTime());
  return <img src={`${IMPRESSION_TRACKING_ASSET_URL}?date=${date}`} style={{ width: 1, height: 1 }} alt="" />;
};

export const ArkheronMastheadFeature: React.FC<any> = (props: any) => {
  const size = useMedia(
    ['(max-width: 600px)', '(max-width: 768px)', '(max-width: 1024px)'],
    [
      { ...MEDIUM_SIZE, type: 'portrait' },
      { ...SMALL_SIZE, type: 'landscape' },
      { ...MEDIUM_SIZE, type: 'landscape' }
    ],
    {
      width: 400,
      height: 225,
      type: 'landscape'
    }
  );

  const isMobile = size.type === 'portrait';

  const primaryStream = {
    live: !isMobile,
    autoplay: !isMobile,
    ...props.streamers[0],
    size
  };

  return (
    <div
      className={cx(
        'rio-stream-masthead rio-fuzzy-border rio-fuzzy-border--large slds-text-align--center slds-m-bottom--small slds-grid slds-grid--vertical-align-center slds-grid--align-center slds-p-around--small slds-p-left--medium',
        props.className
      )}
      style={{
        backgroundImage: `url(${asset(size.type === 'portrait' ? '/images/site/mastheads/arkheron-2026/arkheron_bg_portrait.png' : '/images/site/mastheads/arkheron-2026/arkheron_bg_landscape.png')})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center top'
      }}
    >
      <ImpressionTracker />
      <Row wrap verticalAlign="center">
        <Col xs={12} sm={12} smm={6} md={6} lg={6} xl={6}>
          <InteractiveStreamPreview
            key={primaryStream.stream.name}
            type="twitch"
            thumbnailUrl={primaryStream.stream.thumbnail_url}
            width={primaryStream.size.width}
            height={primaryStream.size.height}
            thumbnailWidth={primaryStream.size.width}
            thumbnailHeight={primaryStream.size.height}
            viewerCount={primaryStream.stream.viewer_count}
            streamIdentifier={primaryStream.stream.name}
            isFeatured={true}
            live={primaryStream.live}
            autoplay={primaryStream.autoplay}
            className={cx('stream--larger', primaryStream.className)}
          />
        </Col>
        <Col xs={12} sm={12} smm={6} md={6} lg={6} xl={6}>
          <TrackedLink href={CTA_URL} as="arkheron:demo_cta" target="_blank">
            <div>
              <img
                src={asset('/images/site/mastheads/arkheron-2026/arkheron_logo.png')}
                alt="ARKHERON"
                style={{ maxWidth: '100%' }}
              />
            </div>
            <img
              src={asset('/images/site/mastheads/arkheron-2026/arkheron_cta_button.png')}
              alt="PLAY THE DEMO NOW"
              style={{ maxWidth: '100%' }}
            />
          </TrackedLink>
        </Col>
      </Row>
    </div>
  );
};
